import React, { useContext } from "react";
import AutocompleteInput from "components/FormElements/AutocompleteInput";
import Label from "components/FormElements/Label";
import { useAuth } from "hooks/Auth";
import { apiGet } from "helpers/Request";
import { transform as tagTransformer } from "schemas/Tag";
import { ContainerContext } from "context/Container";

function TagField(props) {
    const auth = useAuth();
    const { state } = useContext(ContainerContext);

    if (state.loading) {
        return (
            <div>
                <Label>Tags</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    return (
        <AutocompleteInput
            label="Tags"
            name="tags"
            id="tags"
            disabled={
                state.loading ||
                state.performingStateChange ||
                !state.isUserEditable
            }
            onRequestSearch={async (term) => {
                const items = await apiGet("/v4/search", auth.publication, {
                    keyword: term,
                    per_page: 40,
                    type: "tag",
                });

                return tagTransformer(items).map((item) => {
                    return {
                        label: item.name,
                        value: item.uuid,
                    };
                });
            }}
        />
    );
}

export default TagField;
